export default __webpack_public_path__ + "static/media/close.b4025689.svg";